export default __webpack_public_path__ + "static/media/onboarding_second_mobile.14525a6f.png";